import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components";
import Header from "../components/header";
import Footer from './../components/Footer';
const PageNotFound = () => {
  return (
    <>
      <Header />
      <main className="hero" style={{ minHeight: '76vh' }}>
        <div className="container my-3 py-3">
          <div className="container justify-content-center text-center">
            <div className="row">
              <h2 className="fw-bold mb-3" style={{fontSize:'50px'}}>404: Page Not Found</h2>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Link to="/" className="btn btn_black">
                  <i className="fa fa-home me-2"></i> Back To Home
                </Link>

              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PageNotFound;
